$a.each_current_and_future('time.js-time-ago', function (el) {
  return el.timeago();
});